import { Component } from "react";

class MatchUtils extends Component {
  static GAME_TG = 1;
  static GAME_1VS1 = 2;
  static GAME_UNKNOW = -1;

  static getMatchType(matchId, matches) {
    let match = MatchUtils.getMatch(matchId, matches);
    if (match === undefined) {
      return MatchUtils.GAME_UNKNOW;
    }

    if (match && match.num_players && match.num_players > 2) {
      return MatchUtils.GAME_TG;
    } else if (match && match.num_players && match.num_players <= 2) {
      return MatchUtils.GAME_1VS1;
    } else {
      console.log(
        `getMatchType unknow: ${JSON.stringify(
          match
        )} [${matchId}] [matches: ${JSON.stringify(matches)}]`
      );
      return MatchUtils.GAME_UNKNOW;
    }
  }

  static getMatch(matchId, matches) {
    let result = matches.filter((match) => match.match_id === matchId);
    if (result && result.length > 0) {
      return result[0];
    } else {
      return undefined;
    }
  }
}

export default MatchUtils;
